// CONSTANT FOR FORM
import { accessLevelControl, hiredOnControl, stressProfileControl } from '../../../../../constants/form-control/employee/job-information';

// INTERFACE AND ENUMS
import { Field, FormFieldConfig } from '../../../../../models/common/forms/form-field-config';

// DATA TYPES
import { FormDataType } from '../../../../../constants/enum/common/form-data-type';

// CONSTANT
import { SAVE_BUTTON_CONFIG } from '../../../../../constants/button';
import { JOB_INFORMATION_BUTTON_CONSTANT } from '../../../../../constants/translate-messages/button';
import { FormControlUtil } from '../../../../../core/utils/form-control';
import { ButtonConfig } from '../../../../../models/common/forms/button';
import { selectControl } from '../../../../../constants/form-control/core/common/select/select';

export const employmentTypeControl: Field = FormControlUtil.mergeFormControl(selectControl, {
  key: 'employee_employment_type',
  templateOptions: FormControlUtil.mergeFormControl(selectControl.templateOptions, {
    label: 'Employment Type',
    bindLabel: 'business_configuration_name',
    bindValue: 'business_configuration_name',
    multiple: false,
    selectOptions: {
      checkboxSelection: false,
      inputDropDown: false,
      unClearable: true,
    },
  }),
  validations: {
    validators: {
      required: true
    }
  }
});

/**
 * This constant used for Job Information Form
 */
export const JOB_INFORMATION_FORM_CONTROLS: FormFieldConfig[] = [
  {
    row: 1,
    fields: [
      accessLevelControl,
      // stressProfileControl,
    ],
  },
  // {
  //   row: 2,
  //   fields: [
  //     hiredOnControl,
  //     employmentTypeControl
  //   ],
  // },
];



/**
 * This constant used for Job Information Model for payload
 */
export const JOB_INFORMATION_FORM_MODEL = {
  employee_id: { type: FormDataType.NUMBER, revert: FormDataType.NUMBER, default: 0 },
  employee_fk_access_level_id: { type: FormDataType.NUMBER, revert: FormDataType.NUMBER, default: 0 },
  employee_hired_on: { type: FormDataType.DATE, revert: FormDataType.DATE, default: null },
  stress_profile: { type: FormDataType.SELECT, revert: FormDataType.SELECT, keys: { stress_profile: { business_stress_profile_id: 'employee_fk_stress_profile_id', business_stress_profile_name: 'employee_fk_stress_profile_name' } } },
  employee_employment_type: { type: FormDataType.STRING, revert: FormDataType.STRING, default: null },
};


/**
 * Button config
 */
export const CUSTOM_SAVE_BUTTON_CONFIG: ButtonConfig = FormControlUtil.mergeFormControl(
  SAVE_BUTTON_CONFIG,
  {
    options: FormControlUtil.mergeFormControl(SAVE_BUTTON_CONFIG.options, {
      text: JOB_INFORMATION_BUTTON_CONSTANT.TEXT,
    }),
  },
);
